import type { XscpDocument, XscpMeta, XscpPayload } from './types.js';

/**
 * Webflow's copy-side report of what it stripped on the way out.
 *
 * We are the producer, not Webflow, so there is nothing to report — but the keys must be
 * present. `meta` gained `universalBindingsRemovedCount` and `codeComponentsRemovedCount`
 * some time after 2022, which is one of the two observed drifts in this format.
 */
export const EMPTY_META: XscpMeta = {
  unlinkedSymbolCount: 0,
  droppedLinks: 0,
  dynBindRemovedCount: 0,
  dynListBindRemovedCount: 0,
  paginationRemovedCount: 0,
  universalBindingsRemovedCount: 0,
  codeComponentsRemovedCount: 0,
};

export function wrapEnvelope(payload: XscpPayload): XscpDocument {
  return { type: '@webflow/XscpData', payload, meta: { ...EMPTY_META } };
}
